import ClubAbout from './ClubAbout';

export default ClubAbout;
